import type { DcEnvironmentCode, DcTenantCode } from '@rma/generic/core/instance';

type CountryCode = 'AU' | 'NZ' | 'US';

export class Environment {
  AbandonedCartContactNumber: string;
  basePath: string;
  baseUrl: string;
  blog: string;
  countryCode: CountryCode;
  dashboardFeedbackUrl: string;
  domain: string;
  emailApiUrl: string;
  facebookApiVersion: string;
  facebookId: string;
  facebookPixelId: string;
  agentTargetingFacebookPixelId: string;
  agentTargetingGoogleAdWordsTag: string;
  googleTagManagerMegaphone: string;
  agentTargetingLinkedinPartnerId: string;
  facebookUrl: string;
  googleAdwordsConversionId: string;
  googleClientId: string;
  googleMapKey: string;
  googleMyBusinessHelpUrl: string;
  googleMyBusinessUrl: string;
  googlePromoterRemarketingId: string;
  googleTagManagerWebId: string;
  chameleonToken: string;
  itunesAppStoreId: string;
  jwtEnvironment: string;
  datadomeJsKey: string;
  languageUrl: string;
  launchDarklyClientId: string;
  // PLEASE MAKE YOUR TYPES, DON'T JUST DISABLE IT
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  launchDarklyFlags: Record<string, any> | null;
  locale: 'en-AU' | 'en-NZ' | 'en-US';
  oAuthKey: string;
  onboardingWebinarRegistrationUrl: string;
  posthogProjectToken: string;
  posthogHost: string;
  pushNotificationVapidPublicKey: string;
  recaptchaKey: string;
  rmaVersion: string;
  stripePublishKey: string;
  heapAppId: string;
  supportUrl: string;
  trainingUrl: string;
  version: string;
  zillowUrl: string;
  identityUrl: string;
  identityClient: string;
  identitySecret: string;
  merchandiseStoreUrl: string;
  tenant: DcTenantCode;
  environment: DcEnvironmentCode;
  crmApiUrl: string;
  taxPercent: number; // this should be removed...
  dashboardUrl: string; // Used during migration
  legacyUrl: string; // Used during migration
  // test properties
  isLocal?: boolean;
  useStubFeatures?: boolean;
  algoliaApplicationId: string;
  algoliaSearchApiKey: string;
  algoliaDashboardFeaturesIndexName: string;
  zapierDashboardUrl: string;
}

/**
 * @deprecated Please inject `Environment` to access config properties
 */
// PLEASE MAKE YOUR TYPES, DON'T JUST DISABLE IT
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rmaProperties: Environment = (window as any).rmaProperties;
